export default __webpack_public_path__ + "static/media/LogoBN.6c5a4f29.png";